/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  // GK-HUB: Conversation Timeline (Fase 5 TMA Real)
  getTimeline(conversationID) {
    return axios.get(`${this.url}/${conversationID}/timeline`);
  }
}

export default new ConversationApi();
